/**
 * WebSocket bearer-auth wire format, shared by every WS client in the app.
 *
 * Lives in `shared/api` rather than beside its first consumer because it is a
 * CONTRACT WITH THE BACKEND (`extractToken` in the BE's `updates.gateway.ts`
 * parses exactly this).
 */

/** Subprotocol marker preceding the base64url-encoded token (k8s-style). */
export const BEARER_SUBPROTOCOL = 'cc.bearer';

/**
 * Browsers cannot set an `Authorization` header on a WS upgrade, and a URL query
 * parameter would leak the token into access and OTel logs — so it rides in
 * `Sec-WebSocket-Protocol`. base64url because the raw `accessToken:idToken` value
 * contains `:`, which the subprotocol grammar forbids.
 */
export const toBase64Url = (value: string): string =>
  btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

/**
 * The subprotocol array for a WS upgrade. An absent token yields an EMPTY array
 * rather than a partial one: the BE admits a tokenless upgrade only under its
 * paired BYPASS_MODE, and sending a marker with no token would be neither.
 */
export const buildBearerProtocols = (
  token: string | null | undefined,
): string[] => (token ? [BEARER_SUBPROTOCOL, toBase64Url(token)] : []);
